import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import {
  AuthService,
  MetadataService,
  Product,
  ProductArticleClassFilterService,
  ProductService,
  ProductGridViewComponent,
  ProductSortService,
  GungFlowService,
  LocationConfigService,
  CloudPimFiltersService,
  CurrentAssortmentService
} from 'gung-standard';
import {
  JeevesProductListConfigService,
  ProductItemGroupFilterService,
  JeevesProductGridViewComponent
} from 'gung-standard-jeeves';
import { RefJeevesProductTableComponent } from '../../components/ref-jeeves-product-table/ref-jeeves-product-table.component';
import { environment } from './../../../environments/environment';
import { RefJeevesProductGridViewComponent } from '../../components/ref-jeeves-product-grid-view/ref-jeeves-product-grid-view.component';

export class RefProductItemGroupFilterService extends ProductItemGroupFilterService {
  constructor(protected metadataService: MetadataService) {
    super(metadataService);
  }

  isActiveFromStart = () => true;

  getName(): string {
    return 'ITEM_GROUP';
  }
  getOptionIds(item: Product): string[] {
    return [item.extra.ar.varugruppkod];
  }
  getOptionName(key: string): string {
    const metaValue = this.metadataService.getMetadataValue('vg', 'varugruppbeskr', key);
    return metaValue || key;
  }
}

export class RefProductCustomItemGroupFilter extends ProductItemGroupFilterService {
  constructor(protected metadataService: MetadataService) {
    super(metadataService);
  }

  isActiveFromStart = () => true;

  getName(): string {
    return 'ITEM_GROUP';
  }
  getOptionIds(item: Product): string[] {
    return [item.extra.ar.itemtypecd2];
  }
  getOptionName(key: string): string {
    const metaValue = this.metadataService.getMetadataValue('atp2', 'itemtypedesc', key);
    return (metaValue || key).toLowerCase();
  }
}

@Injectable({
  providedIn: 'root'
})
export class RefProductListConfigService extends JeevesProductListConfigService {
  constructor(
    protected authService: AuthService,
    protected productService: ProductService,
    protected productItemGroupFilterService: ProductItemGroupFilterService,
    protected productArticleClassFilterService: ProductArticleClassFilterService,
    protected productSortService: ProductSortService,
    private metadataService: MetadataService,
    gungFlowService: GungFlowService,
    locationConfigService: LocationConfigService,
    protected cloudPimFiltersService: CloudPimFiltersService,
    protected currentAssortmentService: CurrentAssortmentService
  ) {
    super(
      authService,
      productService,
      productItemGroupFilterService,
      productArticleClassFilterService,
      productSortService,
      gungFlowService,
      locationConfigService,
      cloudPimFiltersService,
      currentAssortmentService
    );
  }

  getBatchSizes() {
    if (environment.projectName !== 'ref') {
      return [48];
    }

    return [300];
  }

  getFilters(): ConfigBaseFilter<Product>[] {
    const filters: ConfigBaseFilter<Product>[] = [this.productArticleClassFilterService];
    if (environment.projectName === 'ref') {
      filters.push(new RefProductCustomItemGroupFilter(this.metadataService));
    } else {
      filters.push(new RefProductItemGroupFilterService(this.metadataService));
    }

    return filters;
  }

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fas fa-list',
        getListItemComponent: () => RefJeevesProductTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductList'
      },
      {
        getIconClass: () => 'fas fa-th',
        getListItemComponent: () => RefJeevesProductGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }
}
